import Button from "@kamae-apps/shared/old/Component/Button/Button"
import Slider from "@kamae-apps/shared/old/Component/Input/Slider"
import React, { FC } from "react"
import { CompanyData } from "../../../Companies"
import { CalendarTypeSection } from "../../Components/CalendarTypeSection"
import { ElearningCategory } from "../../Components/ElearningCategory"
import { useElearningContainer } from "./useElearningContainer"

type ElearningContainerProps = {
  company: CompanyData
  setCompany: (value: CompanyData) => void
}
export const ElearningContainer: FC<ElearningContainerProps> = ({ company, setCompany }) => {
  const {
    loading,
    allChecked,
    elearnings,
    check,
    setCheck,
    monthDelta,
    setMonthDelta,
    companyModules,
    changeCheckAll,
    saveElearnings,
    updateCalendarType,
    referenceDate,
  } = useElearningContainer(company, setCompany)

  return (
    <div className={"flex h-full w-full flex-col p-3"}>
      <div className={"mb-3 flex items-center justify-between"}>
        <div className={"flex items-center gap-2 text-sm text-gray-500"}>
          <span>Date de référence :</span>
          {company.user_centric_calendar ? (
            <span className={"italic text-gray-500"}>
              date la plus récente entre l'inscription du collaborateur et le{" "}
              <span className={"font-medium text-gray-700"}>
                {referenceDate.date.toLocaleDateString("fr-FR")}
              </span>{" "}
              <span className={"rounded-full bg-gray-100 px-2 py-0.5 text-xs"}>
                {referenceDate.source === "onboarding" ? "Onboarding" : "Début de licence"}
              </span>
            </span>
          ) : (
            <>
              <span className={"font-medium text-gray-700"}>
                {referenceDate.date.toLocaleDateString("fr-FR")}
              </span>
              <span className={"rounded-full bg-gray-100 px-2 py-0.5 text-xs"}>
                {referenceDate.source === "onboarding" ? "Onboarding" : "Début de licence"}
              </span>
            </>
          )}
        </div>
        <CalendarTypeSection
          company={company}
          onCalendarTypeChange={e => updateCalendarType(e.target.checked)}
        />
      </div>
      <div className={"flex w-11/12 items-center 2xl:w-1/2"}>
        <Slider
          className={"m-1"}
          checked={allChecked}
          onChange={changeCheckAll}
        />
        <p>Tout sélectionner</p>
        <div className={"grow"} />
      </div>
      <div className={"mt-4 flex h-5/6 justify-evenly p-3"}>
        {elearnings && companyModules ? (
          <>
            {companyModules.some(module => module.category === "Company") && (
              <ElearningCategory
                categoryKey={"Company"}
                categoryName={"Cybersécurité"}
                elearnings={elearnings}
                check={check}
                setCheck={setCheck}
                monthDelta={monthDelta}
                setMonthDelta={setMonthDelta}
                referenceDate={referenceDate.date}
              />
            )}
            {companyModules.some(module => module.category === "Home") && (
              <ElearningCategory
                categoryKey={"Home"}
                categoryName={"À la maison"}
                elearnings={elearnings}
                check={check}
                setCheck={setCheck}
                monthDelta={monthDelta}
                setMonthDelta={setMonthDelta}
                referenceDate={referenceDate.date}
              />
            )}
            {companyModules.some(module => module.category === "RGPD") && (
              <ElearningCategory
                categoryKey={"RGPD"}
                categoryName={"RGPD"}
                elearnings={elearnings}
                check={check}
                setCheck={setCheck}
                monthDelta={monthDelta}
                setMonthDelta={setMonthDelta}
                referenceDate={referenceDate.date}
              />
            )}
          </>
        ) : (
          <p>Loading</p>
        )}
      </div>
      <div className={"flex justify-center"}>
        <Button
          className={
            "border-primary-600 text-primary-600 hover:bg-primary disabled:border-primary-200 disabled:text-primary-200 px-8 py-2 transition-colors hover:text-white disabled:bg-white"
          }
          onClick={saveElearnings}
          disabled={loading}
        >
          Sauvegarder
        </Button>
      </div>
    </div>
  )
}
